<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="7" @click="toNewRouter('investment-over-view')" v-if="permissionCodes.indexOf('002004000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>
        <span slot="title">概览</span>
      </el-menu-item>

      <el-submenu index="2" v-if="permissionCodes.indexOf('002001000') !== -1 || permissionCodes.indexOf('002002000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-fangwuzujin"></i>
          <span>合同管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="2-1" @click="toNewRouter('contract-management')" v-if="permissionCodes.indexOf('002001000') !== -1">合同列表</el-menu-item>
          <el-menu-item index="2-2" @click="toNewRouter('filing-contract')" v-if="permissionCodes.indexOf('002002000') !== -1">归档合同</el-menu-item>
          <!--<el-menu-item index="2-3" @click="toNewRouter('contract-template')" v-if="permissionCodes.indexOf('002006000') !== -1">合同模板</el-menu-item>-->
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="8" v-if="(permissionCodes.indexOf('002005000') !== -1 || permissionCodes.indexOf('002011000') !== -1 || permissionCodes.indexOf('002006000') !== -1 || permissionCodes.indexOf('002007000') !== -1)">
        <template slot="title">
          <i class="el-icon-damai-hetong2"></i>
          <span>其他合约管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="8-1" @click="toNewRouter('other-contract-management')" v-if="permissionCodes.indexOf('002005000') !== -1">合约列表</el-menu-item>
          <el-menu-item index="8-2" @click="toNewRouter('other-filing-contract')" v-if="permissionCodes.indexOf('002011000') !== -1">归档合约</el-menu-item>
          <el-menu-item index="8-3" @click="toNewRouter('other-rent-management')" v-if="permissionCodes.indexOf('002006000') !== -1">账单管理</el-menu-item>
<!--          <el-menu-item index="8-4" @click="toNewRouter('business-address-registration')" v-if="permissionCodes.indexOf('002007000') !== -1">工商地址注册管理</el-menu-item>-->
          <el-menu-item index="8-5" @click="toNewRouter('other-bill-type-manage')" v-if="permissionCodes.indexOf('002012000') !== -1">账单类型</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="3" v-if="(permissionCodes.indexOf('002005000') !== -1 || permissionCodes.indexOf('002008000') !== -1 || permissionCodes.indexOf('002006000') !== -1 || permissionCodes.indexOf('002007000') !== -1)">
        <template slot="title">
          <i class="el-icon-damai-hetong2"></i>
          <span>租金管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="3-1" @click="toNewRouter('rent-management')" v-if="permissionCodes.indexOf('002008000') !== -1">主体账单</el-menu-item>
          <el-menu-item index="3-2" @click="toNewRouter('rent-room-management')" v-if="permissionCodes.indexOf('002008000') !== -1">房间账单</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

<!--      <el-menu-item index="3" @click="toNewRouter('rent-management')" v-if="permissionCodes.indexOf('002008000') !== -1">
        <i class="el-icon-damai-hetong1"></i>
        <span slot="title">租金管理</span>
      </el-menu-item>-->

      <el-submenu index="4" v-if="(permissionCodes.indexOf('002005000') !== -1 || permissionCodes.indexOf('002009000') !== -1 || permissionCodes.indexOf('002006000') !== -1 || permissionCodes.indexOf('002007000') !== -1)">
        <template slot="title">
          <i class="el-icon-damai-hetong2"></i>
          <span>物业费管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="4-1" @click="toNewRouter('property-management')" v-if="permissionCodes.indexOf('002009000') !== -1">主体账单</el-menu-item>
          <el-menu-item index="4-2" @click="toNewRouter('property-room-management')" v-if="permissionCodes.indexOf('002009000') !== -1">房间账单</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
<!--      <el-menu-item index="4" @click="toNewRouter('property-management')" v-if="permissionCodes.indexOf('002009000') !== -1">
        <i class="el-icon-damai-wuyefeiyongchuzhang"></i>
        <span slot="title">物业费管理</span>
      </el-menu-item>-->

      <el-submenu index="5" v-if="(permissionCodes.indexOf('002005000') !== -1 || permissionCodes.indexOf('002010000') !== -1 || permissionCodes.indexOf('002006000') !== -1 || permissionCodes.indexOf('002007000') !== -1)">
        <template slot="title">
          <i class="el-icon-damai-hetong2"></i>
          <span>保证金及其他管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="5-1" @click="toNewRouter('deposit-management')" v-if="permissionCodes.indexOf('002010000') !== -1">主体账单</el-menu-item>
          <el-menu-item index="5-2" @click="toNewRouter('deposit-room-management')" v-if="permissionCodes.indexOf('002010000') !== -1">房间账单</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
<!--      <el-menu-item index="5" @click="toNewRouter('deposit-management')" v-if="permissionCodes.indexOf('002010000') !== -1">
        <i class="el-icon-damai-yajin"></i>
        <span slot="title">保证金及其他管理</span>
      </el-menu-item>-->

      <el-menu-item index="6" @click="toNewRouter('investment-leasing-log')" v-if="permissionCodes.indexOf('002003000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({

  "2-1": [
    "contract-management",
    "contract-add",
    "contract-modify",
    "contract-current",
    "rent-withdrawal",
    "rent-withdrawal-detail",
    "contract-renewal",
  ],
  "2-2": [
    "filing-contract",
    "filing-rent-withdrawal-detail",
    "filing-contract-detail",
    "filing-contract-current",
  ],
  "2-3": ["contract-template"],
  // 3: ["rent-management", "rent-modify"],
  "3-1": ["rent-management", "rent-modify"],
  "3-2": "rent-room-management",
  // 4: ["property-management", "property-modify"],
  "4-1": ["property-management", "property-modify"],
  "4-2": "property-room-management",
  // 5: ["deposit-management", "deposit-modify"],
  "5-1": ["deposit-management", "deposit-modify"],
  "5-2": "deposit-room-management",
  6: "investment-leasing-log",
  7: "investment-over-view",
  "8-1": [
    "other-contract-management",
    "other-contract-add",
    "other-contract-current",
    "other-contract-modify",
    "other-rent-withdrawal",
    "other-rent-withdrawal-detail",
    "other-contract-renewal",
  ],
  "8-2": [
    "other-filing-contract",
    "other-filing-contract-current",
    "other-filing-rent-withdrawal-detail",
    "other-filing-contract-detail",
  ],
  "8-3": ["other-rent-management"],
  "8-4": ["business-address-registration"],
  '8-5': ['other-bill-type-manage']
});

export default {
  name: "investment-leasing-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      yqCode: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.yqCode = bus.global.yqCode;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/InvestmentLeasing/InvestmentLeasingNav.vue